export default "__VITE_ASSET__e526d710__"